<template>
  <router-link
    :to="'/articles/'+article.id+'?provenance_cluster_id='+provenanceCluster.id+'&provenance_cluster_title='+provenanceCluster.title"
    class="relative flex flex-col overflow-hidden rounded-lg shadow-lg"
  >
    <template v-if="article.read">
      <div class="bg-primary-900 opacity-70 absolute inset-0 w-full h-full" />
      <div class="drop-shadow absolute inset-0 flex items-center justify-center w-full h-full font-semibold text-white">
        Article read
      </div>
    </template>
    <div class="flex-shrink-0">
      <img
        class="object-cover w-full h-48"
        :src="article.images[0].url"
        :alt="article.title"
      >
    </div>
    <div class="flex flex-col justify-between flex-1 p-6 bg-white">
      <div class="flex-1">
        <div class="flex flex-wrap">
          <div
            v-for="cluster in article.clusters"
            :key="cluster.id"
            class="p-1"
          >
            <router-link
              :to="`/news-feed/${cluster.id}/articles`"
              class="inline-block px-2 py-0.5 text-xs font-medium text-white rounded text-primary-400 bg-primary-50"
            >
              {{ cluster.title }}
            </router-link>
          </div>
        </div>
        <div class="mt-2">
          <p class="text-xl font-semibold text-gray-900">
            {{ article.title }}
          </p>
          <p class="mt-2 text-base leading-tight text-gray-500">
            {{ article.teaser }}
          </p>
        </div>
      </div>
      <div class="mt-6">
        <div
          v-if="article.author"
          class="text-sm font-medium text-gray-900"
        >
          <p class="hover:underline">
            {{ article.author }}
          </p>
        </div>
        <div class="flex space-x-1 text-sm text-gray-500">
          <time :date="article.publishing_date">
            {{ $dayjs(article.publishing_date).format('LL') }}
          </time>
          <span aria-hidden="true">
            &middot;
          </span>
          <span>
            {{ readingTime }} min read
          </span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    article: {
      required: true,
      type: Object
    },
    provenanceCluster: {
      required: true,
      type: Object
    }
  },
  computed:  {
    readingTime() {
      return Math.ceil(((this.article.minimum_reading_time * 2) /  60));
    }
  }
};
</script>
